import React from "react";

interface SheetBodyProps {
  children: React.ReactNode;
  /** Custom className */
  className?: string;
}

/**
 * SheetBody - Scrollable content area of the sheet
 */
export function SheetBody({ children, className = "" }: SheetBodyProps) {
  return (
    <div
      className={`
        flex-1
        overflow-y-auto overflow-x-hidden
        p-2xl
        ${className}
      `}
    >
      {children}
    </div>
  );
}
